import React from "react";

import styles from "./DotElastic.module.scss";

interface DotElasticProps {
  color?: string;
}

const DotElastic: React.FC<DotElasticProps> = ({ color }) => {
  return (
    <div data-title="dot-elastic">
      <div>
        <div
          className={styles.dotElastic}
          style={
            color
              ? ({ "--dot-color": color } as React.CSSProperties)
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default DotElastic;
